import { render } from "./WatchlistSearchCard.vue?vue&type=template&id=c8a37364&scoped=true"
import script from "./WatchlistSearchCard.vue?vue&type=script&lang=js"
export * from "./WatchlistSearchCard.vue?vue&type=script&lang=js"

import "./WatchlistSearchCard.vue?vue&type=style&index=0&id=c8a37364&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/dotter/dotter/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8a37364"]])

export default __exports__